import { useEffect, useState } from "react";
import { BlockView } from "@/components/content/BlockView";
import { LoginCard, mergeLogin } from "@/components/LoginCard";
import { ForgotDialog } from "@/components/ForgotDialog";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";

const DEFAULT_BLOCKS = [{ id: "front-banner", type: "banner", title: "MWJK", body: "Midwest Jitõbõn Kõmaroñroñ\nTithes, conference collections, progress reports and conference registration for our churches — in one simple place.", image_id: null, font: "Cabinet Grotesk", size: "xl", color: "#ffffff", bg: "#6b1e2e", align: "left", height: "full", divider_style: "solid", visible: true }];

export default function Login() {
  const { login, logoUrl, loginStyle } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [blocks, setBlocks] = useState(null);
  const [forgot, setForgot] = useState(false);
  const s = mergeLogin(loginStyle);
  useEffect(() => { api.get("/public/content/front").then((r) => setBlocks(r.data.blocks.length ? r.data.blocks : DEFAULT_BLOCKS)).catch(() => setBlocks(DEFAULT_BLOCKS)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="flex flex-col bg-[hsl(var(--primary))] lg:min-h-screen" data-testid="front-blocks">
        {blocks && blocks.map((b, i) => <BlockView key={b.id} block={b} fill logo={b.type === "banner" && i === blocks.findIndex((x) => x.type === "banner") ? logoUrl : undefined} />)}
      </div>
      <div className="site-bg flex items-center justify-center bg-background px-6 py-12" style={s.page_bg ? { backgroundColor: s.page_bg } : undefined} data-testid="login-side">
        <LoginCard s={s} form={{ email, password, setEmail, setPassword, error, busy, onSubmit: submit, onForgot: () => setForgot(true) }} />
        {forgot && <ForgotDialog open onClose={() => setForgot(false)} initial={email} />}
      </div>
    </div>
  );
}
